import config from '@plone/volto/registry';

/** Hostname used in block JSON when content was saved from Docker Compose. */
const DOCKER_PLONE_BACKEND = /^https?:\/\/webunite-backend:8080\/Plone/i;

export function rewriteBackendUrl(url) {
  if (!url || typeof url !== 'string') return url;
  const base =
    config.settings.internalApiPath || config.settings.apiPath || '';
  if (!DOCKER_PLONE_BACKEND.test(url) || !base) return url;
  return url.replace(DOCKER_PLONE_BACKEND, base.replace(/\/$/, ''));
}

/** Normalize @id / image download URLs on catalog or block image objects. */
export function normalizeImageItem(item) {
  if (!item || typeof item !== 'object') return item;

  const normalized = { ...item };
  if (normalized['@id']) {
    normalized['@id'] = rewriteBackendUrl(normalized['@id']);
  }

  const image = normalized.image;
  if (image && typeof image === 'object' && !Array.isArray(image)) {
    const nextImage = { ...image };
    if (nextImage.download) {
      nextImage.download = rewriteBackendUrl(nextImage.download);
    }
    if (nextImage.scales) {
      nextImage.scales = Object.fromEntries(
        Object.entries(nextImage.scales).map(([key, scale]) => [
          key,
          scale
            ? { ...scale, download: rewriteBackendUrl(scale.download) }
            : scale,
        ]),
      );
    }
    normalized.image = nextImage;
  }

  return normalized;
}
